import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import MdFilterNone from 'react-icons/lib/md/filter-none';
import { fetchDocuments, fetchDocumentTags } from '../../actions/project_actions';
import { calcPageCount } from '../../utils';
import UploadZone from './dropzone';
import DocumentsTable from './documents_table';
import DocumentFilters from './DocumentFilters';

class ProjectDocuments extends Component {

    constructor (props) {
        super(props);
        
        this.state = {
            currentType: '',
            currentTag: '',
            currentUser: '',
            currentPage: 0,
            currentPg: 1,
            itemsPerPg: 10
        }

        this.filterByType = this.filterByType.bind(this);
        this.filterByTag = this.filterByTag.bind(this);
        this.filterByUser = this.filterByUser.bind(this);
        this.loadDocuments = this.loadDocuments.bind(this);
        this.loadDocumentTags = this.loadDocumentTags.bind(this);

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.loadDocuments();
        this.loadDocumentTags();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { count, pageSize } = nextProps;
        const pageCount = calcPageCount(count, pageSize);

        const { currentPage } = this.state;
        if (currentPage >= pageCount)
            this.setState({ currentPage: pageCount - 1 },
        () => {
            this.loadDocuments();
            this.loadDocumentTags();
        }
      );

        if (nextProps.documents.length === 10) {
            this.setState({
                currentPg: 1
            });
        }
    }

    loadDocuments (currentPage=0, afterUpload=false) {
        const { count, pageSize } = this.props;
        const pageCount = calcPageCount(count, pageSize);
        if (currentPage > pageCount - 1) currentPage = pageCount - 1;
        if (afterUpload) currentPage = pageCount -1;
        if (currentPage === -1) currentPage = 0;
        this.props.fetchDocuments(this.props.projectId, currentPage);
    }

    loadDocumentTags () {
        if (this.props.documentTags.length === 0)
            this.props.fetchDocumentTags();
    }

    filterByType (type) {
        if (this.state.currentType === type) type = '';
        this.setState({ currentType: type });
    }

    filterByTag (tag) {
        if (this.state.currentTag === tag) tag = '';
        this.setState({ currentTag: tag });
    }

    filterByUser (userId) {
        if (this.state.currentUser === userId) userId = '';
        this.setState({ currentUser: userId });
    }

    filterDocuments (documents, currentType, currentTag, currentUser) {
        let result = [...documents];
        if (currentType) {
            result = _.filter(result, {documentType: currentType});
        }
        if (currentTag) {
            result = _.filter(result, (doc) => _.some(doc.tags, {value: currentTag}));
        }
        if (currentUser) {
            result = _.filter(result, (doc) => doc.createdUser.id === currentUser);
        }
        return result;
    }

    handleClick(event) {
        this.setState({
            currentPg: Number(event.target.id)
        });
    } 

    render () {
        const { projectId, documentTags, permissions, documents, pageSize, count } = this.props;
        const { currentType, currentTag, currentUser, currentPage } = this.state;
        const filtered = this.filterDocuments(documents, currentType, currentTag, currentUser);
        const { roleModules } = permissions.editPrivileges;

        const canEdit = roleModules !== null && roleModules.includes('Documents') 
    ? true : false;
  
        const { currentPg, itemsPerPg } = this.state;

    // Logic for displaying items
        const indexOfLastItem = currentPg * itemsPerPg;
        const indexOfFirstItem = indexOfLastItem - itemsPerPg;
        const currentDocs = filtered.slice(indexOfFirstItem, indexOfLastItem);

    // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.props.documents.length / itemsPerPg); i++) {
            pageNumbers.push(i);
        }
    
        try {
            return (
        <div id="documents" className="row-wide project-documents">
          <div className="col s12">
            <h4 className="bar-bottom">
              <span><MdFilterNone size={20} /></span> Documents
            </h4>
          </div>

          {documents.length > 0 && 
            <div className="col s12 l4">
              <DocumentFilters
                documents={documents}
                currentType={currentType}
                currentTag={currentTag}
                currentUser={currentUser}
                onTypeSelect={this.filterByType}
                onTagSelect={this.filterByTag}
                onUserSelect={this.filterByUser}
              />
            </div>
          }

          {documents.length === 0 && !canEdit &&
            <div className="col s12">
              <div>This project has no documents yet.</div>
            </div>
          }
      
          <div className={'col s12'}>

            {canEdit ?
              <div className="margin-top-1">
                <UploadZone
                  projectId={projectId}
                  documentTags={documentTags}
                  onFileUploaded={() => this.loadDocuments(currentPage, true)}
                  onDrop={this.loadDocumentTags}
                  currentPage={currentPage}
                />
              </div>
              : null
            } 

            {currentDocs.length ? 
              <DocumentsTable
                documents={currentDocs}
                count={count}
                pageSize={pageSize}
                permissions={permissions}
                documentTags={documentTags}
                onDocSaved={() => this.loadDocuments(0, true)}
                onDocDeleted={this.loadDocuments}
                onPage={this.loadDocuments}
                currentPage={currentPage}
              /> 
              : null
            }

        {pageNumbers.length > 1 &&
              <div className="col s12">
                <div className="pagination-blue-book">
                  <ul id="page-numbers">
                    {pageNumbers.map(number => {
                        return <li
                        key={number}
                        id={number}
                        onClick={this.handleClick}
                        className={currentPg === number ? 'active' : ''}
                      >
                        {number}
                      </li>
                    })}
                  </ul>
                </div>
              </div>}
          </div>
        </div>
            );
        } catch (e) {
            console.log('render error: ', e);
        }
    }
}

ProjectDocuments.propTypes = {
    projectId: PropTypes.string.isRequired,
    pageSize: PropTypes.number,
    permissions: PropTypes.object.isRequired,
    documents: PropTypes.array.isRequired,
    count: PropTypes.number,
    documentTags: PropTypes.array.isRequired,
    fetchDocuments: PropTypes.func.isRequired,
    fetchDocumentTags: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
    return {
        projectId: ownProps.projectId,
        documents: state.projectsStore.documents,
        count: state.projectsStore.count,
        pageSize: state.projectsStore.pageSize,
        documentTags: state.projectsStore.documentTags,
    };
}

export default connect(mapStateToProps, {
    fetchDocuments,
    fetchDocumentTags
})(ProjectDocuments);